import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Award, ArrowDown, ArrowRight } from 'lucide-react';
import useWindowSize from 'utils/useWindowSize';
import { openAmbassadorForm } from '../../utils/ambassadorForm';
import {
  HOME_AMBASSADOR_CARD_DISMISSED_KEY,
  SCHEDULER_AMBASSADOR_BANNER_DISMISSED_KEY,
  writeLocalFlag,
} from '../../utils/homePromoStorage';
import styles from './AmbassadorPromoCard.module.scss';

const AmbassadorPromoCard = ({ onDismiss }) => {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();
  const HintArrow = isMobile ? ArrowDown : ArrowRight;

  const dismiss = useCallback(() => {
    writeLocalFlag(HOME_AMBASSADOR_CARD_DISMISSED_KEY);
    writeLocalFlag(SCHEDULER_AMBASSADOR_BANNER_DISMISSED_KEY);
    onDismiss?.();
  }, [onDismiss]);

  const openForm = useCallback(() => {
    writeLocalFlag(SCHEDULER_AMBASSADOR_BANNER_DISMISSED_KEY);
    openAmbassadorForm();
  }, []);

  return (
    <section className={styles.section} id="ambassador-promo" aria-labelledby="ambassador-promo-title">
      <div className={styles.info}>
        <span className={styles.badge}>{t('home.staticBlock.ambassador.badge')}</span>
        <div className={styles.title_row}>
          <span className={styles.logo} aria-hidden>
            <Award size={22} strokeWidth={2.2} />
          </span>
          <h2 id="ambassador-promo-title" className={styles.title}>
            {t('home.staticBlock.ambassador.title')}
          </h2>
        </div>
        <p className={styles.description}>{t('home.staticBlock.ambassador.description')}</p>
        <p className={styles.hint}>
          {t('home.staticBlock.ambassador.hint')}
          <HintArrow size={16} strokeWidth={2.2} aria-hidden />
        </p>
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.button} onClick={openForm}>
          {t('home.staticBlock.ambassador.cta')}
        </button>
        <button type="button" className={styles.dismiss} onClick={dismiss}>
          {t('home.staticBlock.whatsNew.dismissBanner')}
        </button>
      </div>
    </section>
  );
};

export default AmbassadorPromoCard;
